import PopupActionTypes from './PopupTypes';

export const toggleFeedbackPopupHidden = payload => ({
  type: PopupActionTypes.TOGGLE_FEEDBACK_POPUP_HIDDEN,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/PopupActions.js